import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';

import RedirectExternal from '#client/components/RedirectExternal';
import { LOGIN_PATH } from '#client/manifest';
import { buildCartUrl } from '#client/utils/urls';

const FinancialReadiness = () => {
  const { authenticated } = useAuthentication();
  const { businessEntityUuid } = useBusinessEntity();

  if (authenticated) {
    return (<RedirectExternal href={buildCartUrl('zb_money_invoice_setup', { businessEntityUuid })} />);
  }

  return (<RedirectExternal to={`${LOGIN_PATH}?redirectTo=${buildCartUrl('zb_money_invoice_setup', { businessEntityUuid })}`} />);
};

export default FinancialReadiness;
